import React, { useState, useEffect } from 'react';
import axios from 'axios';
import baseURL from './baseURl';
import logo from './logo.new1.png';

const AddToCashAmount = () => {
  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [transaction, setTransaction] = useState(null);
  const [logoBase64, setLogoBase64] = useState(null);

  useEffect(() => {
    const convertLogoToBase64 = async () => {
      try {
        const response = await fetch(logo);
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onloadend = () => {
          setLogoBase64(reader.result);
        };
        reader.readAsDataURL(blob);
      } catch (error) {
        console.error('Error converting logo to base64:', error);
      }
    };
    convertLogoToBase64();
  }, []);

  const handlePrint = () => {
    if (!logoBase64 || !transaction) {
      console.error('Logo or transaction not loaded');
      return;
    }

    const printWindow = document.createElement('iframe');
    document.body.appendChild(printWindow);
  
    const doc = printWindow.contentWindow.document;
    doc.open();
    doc.write('<html><head><title>Print Transaction</title>');
    doc.write('<style>');
    doc.write('body { font-family: Arial, sans-serif; margin: 0; padding: 20px; background-color: #f9f9f9; }');
    doc.write('.container { width: 80%; margin: auto; padding: 20px; background: #fff; border: 1px solid #ccc; border-radius: 8px; }');
    doc.write('h1 { text-align: center; font-size: 14px; margin-bottom: 20px; }');
    doc.write('.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }');
    doc.write('.logo { width: 70px; height: auto; object-fit: contain; }');
    doc.write('.table { width: 100%; border-collapse: collapse; margin-top: 20px; }');
    doc.write('.table th, .table td { border: 1px solid #000; padding: 8px; text-align: center; }');
    doc.write('.table th { background-color: #f2f2f2; }');
    doc.write('.totals { margin-top: 20px; width: 100%; border-collapse: collapse; }');
    doc.write('.total-row { display: grid; grid-template-columns: 1fr 1fr; border: 1px solid #000; }');
    doc.write('.total-row > span { padding: 8px; border-right: 1px solid #000; }');
    doc.write('.total-row > span:first-child { font-weight: bold; text-align: right; background: #f2f2f2; }');
    doc.write('.total-row > span:last-child { text-align: right; border-right: none; }');
    doc.write('.note { margin-top: 20px; padding: 10px; border: 1px solid #ccc; }');
    doc.write('</style>');
    doc.write('</head><body>');
  
    doc.write('<div class="container">');
    doc.write('<h1>|| SHREE GANESHAY NAMH ||</h1>');
    doc.write('<div class="header">');
    doc.write(`<img src="${logoBase64}" class="logo" alt="Logo">`);
    doc.write(`<span>Date: ${new Date(transaction.date).toLocaleDateString()}</span>`);
    doc.write('</div>');
    
    doc.write('<p><strong>Receipt No:</strong> ' + (transaction.receiptNo || 'N/A') + '</p>');
    
    // Table for Transaction Details
    doc.write('<table class="table">');
    doc.write('<thead>');
    doc.write('<tr><th>Cash Amount Added</th></tr>');
    doc.write('</thead>');
    doc.write('<tbody>');
    doc.write(`<tr><td>₹${parseFloat(transaction.amount).toFixed(2)}</td></tr>`);
    doc.write('</tbody>');
    doc.write('</table>');
    
    // Note Section if exists
    if (transaction.note) {
      doc.write('<div class="note">');
      doc.write('<strong>Note:</strong>');
      doc.write(`<p>${transaction.note}</p>`);
      doc.write('</div>');
    }
    
    doc.write('</div>');
    doc.write('</body></html>');
    doc.close();
    
    printWindow.contentWindow.focus();
    printWindow.contentWindow.print();
    document.body.removeChild(printWindow);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      const response = await axios.post(`${baseURL}/api/transactions/add-to-cash-amount`, {
        amount: parseFloat(amount),
        note,
      });

      setTransaction({
        ...response.data,
        date: new Date(),
        amount: parseFloat(amount),
        note: note
      });

      setMessage(response.data.message);
      setShowModal(true);
      setAmount('');
      setNote('');
    } catch (err) {
      console.error(err);
      if (err.response && err.response.data) {
        setError(err.response.data.message);
      } else {
        setError('An unexpected error occurred.');
      }
    }
  };

  return (
    <div className="container mt-4">
      <h2>Add Cash Amount</h2>
      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="amount" className="form-label">Amount</label>
          <input
            type="number"
            className="form-control"
            id="amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
            step="0.001"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="note" className="form-label">Note</label>
          <textarea
            className="form-control"
            id="note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows="3"
          />
        </div>
        <button type="submit" className="btn btn-primary">Add Cash</button>
      </form>

      {/* Receipt Modal */}
      {showModal && transaction && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Transaction Receipt</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <p><strong>Amount Added:</strong> ₹{parseFloat(transaction.amount).toFixed(2)}</p>
                {transaction.note && (
                  <p><strong>Note:</strong> {transaction.note}</p>
                )}
                <p><strong>Date:</strong> {new Date(transaction.date).toLocaleDateString()}</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                <button type="button" className="btn btn-primary" onClick={handlePrint}>Print Receipt</button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Modal Backdrop */}
      {showModal && <div className="modal-backdrop show"></div>}
    </div>
  );
};

export default AddToCashAmount;
